import azure from './assets/azure.png';
import jira from './assets/jira.png';
import testrail from './assets/testRail.png';
import xray from './assets/xray.png';
import zephyr from './assets/zephyrScale.png';

export const IntegrationList = [
  {
    source: 'jira',
    logo: jira,
    label: 'JIRA',
  },
  {
    source: 'azureDevops',
    logo: azure,
    label: 'Azure DevOps',
  },
  {
    source: 'azureDevops',
    namespace: 'testResult',
    logo: azure,
    label: 'Azure DevOps Test Results',
  },
  {
    source: 'testrail',
    logo: testrail,
    namespace: 'testCase',
    label: 'Testrail Testcases',
  },
  {
    source: 'testrail',
    logo: testrail,
    namespace: 'testResult',
    label: 'Testrail Runs',
  },
  {
    source: 'xrayCloud',
    namespace: 'testCase',
    logo: xray,
    label: 'X-Ray Test Cases',
    dependsOn: ['jira'],
  },
  {
    source: 'xrayCloud',
    namespace: 'testResult',
    logo: xray,
    label: 'X-Ray Test Executions',
    dependsOn: ['jira'],
  },
  {
    source: 'zephyrScale',
    namespace: 'testCase',
    logo: zephyr,
    label: 'Zephyr Test Cases',
    dependsOn: ['jira'],
  },
  {
    source: 'zephyrScale',
    namespace: 'testResult',
    logo: zephyr,
    label: 'Zephyr Test Executions',
    dependsOn: ['jira'],
  },
];
